import { Button, type ButtonProps } from '@chakra-ui/react'

import ShwLink from '@/components/ShwLink'
import TrackEventButton from '@/components/UI/TrackEventButton'

import type { CTA, CTAVariant } from './types'

const CTA_BUTTON_STYLES: Record<CTAVariant, ButtonProps> = {
  primary: {
    width: ['100%', 'auto'],
  },
  secondary: {
    width: ['100%', 'auto'],
    variant: 'outline',
  },
}

export default function CTAButton(cta: CTA): JSX.Element | null {
  const { type, label, variant = 'primary', trackEvent, onClick, disabled, style } = cta
  if (type === 'link') {
    const { href, shallow, isExternal } = cta
    return (
      <ShwLink href={href} shallow={shallow} isExternal={isExternal} onClick={onClick}>
        {trackEvent == null ? (
          <Button {...CTA_BUTTON_STYLES[variant]} disabled={disabled} {...style}>
            {label}
          </Button>
        ) : (
          <TrackEventButton
            trackEvent={trackEvent}
            {...CTA_BUTTON_STYLES[variant]}
            disabled={disabled}
            {...style}
          >
            {label}
          </TrackEventButton>
        )}
      </ShwLink>
    )
  }
  if (type === 'button') {
    return trackEvent == null ? (
      <Button onClick={onClick} {...CTA_BUTTON_STYLES[variant]} disabled={disabled} {...style}>
        {label}
      </Button>
    ) : (
      <TrackEventButton
        trackEvent={trackEvent}
        onClick={onClick}
        {...CTA_BUTTON_STYLES[variant]}
        disabled={disabled}
        {...style}
      >
        {label}
      </TrackEventButton>
    )
  }
  return null
}
